import React, { useState } from 'react';
import BackButton from '../components/BackButton';

const Exam = ({ onContinue, onBack }) => {
    const [selectedExam, setSelectedExam] = useState('neet');

    const exams = [
        { id: 'neet', title: 'NEET', desc: 'Medical entrance for MBBS and BDS aspirants.', icon: 'medical_services', color: 'red' },
        { id: 'jee', title: 'JEE', desc: 'Engineering entrance for IITs and NITs.', icon: 'engineering', color: 'blue' },
        { id: 'clat', title: 'CLAT', desc: 'Common Law Admission Test for law schools.', icon: 'gavel', color: 'amber' },
        { id: 'eamcet', title: 'EAMCET', desc: 'State level entrance for technical courses.', icon: 'architecture', color: 'purple' },
    ];

    const getColorClass = (color) => {
        const classes = {
            red: 'bg-red-50 dark:bg-red-900/20 text-red-600',
            blue: 'bg-blue-50 dark:bg-blue-900/20 text-blue-600',
            amber: 'bg-amber-50 dark:bg-amber-900/20 text-amber-600',
            purple: 'bg-purple-50 dark:bg-purple-900/20 text-purple-600',
        };
        return classes[color] || classes.blue;
    };

    return (
        <div className="bg-background-light dark:bg-background-dark text-gray-800 dark:text-gray-100 min-h-screen flex flex-col font-sans antialiased transition-colors duration-300 selection:bg-primary-light selection:text-primary-dark">
            <nav className="w-full bg-surface-light/90 dark:bg-surface-dark/90 backdrop-blur-md border-b border-gray-100 dark:border-gray-800 sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16 items-center">
                        <div className="flex items-center gap-4">
                            <BackButton onClick={onBack} title="Go Back" />
                            <div className="flex items-center gap-2">
                                <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-green-500/30">
                                    H
                                </div>
                                <span className="font-display font-bold text-xl tracking-tight text-gray-900 dark:text-white">Himigo</span>
                            </div>
                        </div>
                        <div className="hidden md:flex space-x-8">
                            <a className="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors text-sm font-medium" href="#">Home</a>
                            <a className="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors text-sm font-medium" href="#">Courses</a>
                            <a className="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors text-sm font-medium" href="#">Mentors</a>
                        </div>
                        <div className="flex items-center gap-4">
                            <button className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                                <span className="material-symbols-outlined">help</span>
                            </button>
                            <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-300 cursor-pointer" onClick={() => document.documentElement.classList.toggle('dark')}>
                                <span className="material-symbols-outlined text-sm">dark_mode</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <main className="flex-grow flex items-center justify-center p-4 relative overflow-hidden">
                <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-primary/10 rounded-full blur-3xl dark:bg-primary/5"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-blue-500/10 rounded-full blur-3xl dark:bg-blue-500/5"></div>

                <div className="w-full max-w-5xl bg-surface-light dark:bg-surface-dark rounded-3xl shadow-2xl shadow-gray-200/50 dark:shadow-black/50 overflow-hidden flex flex-col md:flex-row border border-gray-100 dark:border-gray-700 z-10">
                    {/* Left Column - Info */}
                    <div className="md:w-1/3 bg-gray-50 dark:bg-gray-800/50 p-8 flex flex-col justify-center items-center relative border-b md:border-b-0 md:border-r border-gray-100 dark:border-gray-700">
                        <div className="absolute inset-0 opacity-10 dark:opacity-5" style={{ backgroundImage: 'radial-gradient(#059669 1px, transparent 1px)', backgroundSize: '24px 24px' }}></div>
                        <div className="relative z-10 text-center space-y-6">
                            <div className="w-20 h-20 bg-primary-light dark:bg-primary/20 rounded-2xl flex items-center justify-center mx-auto shadow-sm">
                                <span className="material-symbols-outlined text-primary text-4xl">workspace_premium</span>
                            </div>
                            <div className="space-y-2">
                                <h3 className="font-display font-bold text-2xl text-gray-900 dark:text-white">Exam Selection</h3>
                                <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed max-w-[200px] mx-auto">
                                    Select the competitive exam you are preparing for to personalize your experience.
                                </p>
                            </div>
                            <div className="flex flex-col gap-2 mt-4 text-left mx-auto max-w-[150px]">
                                <div className="flex items-center gap-2 text-xs font-medium text-gray-400">
                                    <span className="w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center text-[10px]">1</span>
                                    <span>Choose Path</span>
                                </div>
                                <div className="h-4 w-px bg-primary ml-3"></div>
                                <div className="flex items-center gap-2 text-xs font-bold text-primary">
                                    <span className="w-6 h-6 rounded-full bg-primary text-white flex items-center justify-center text-[10px]">2</span>
                                    <span>Select Exam</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Selection */}
                    <div className="md:w-2/3 p-8 md:p-12 flex flex-col">
                        <div className="mb-8 text-center md:text-left">
                            <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary-light dark:bg-primary/20 text-primary dark:text-green-300 text-xs font-semibold tracking-wide uppercase mb-4">
                                <span className="w-2 h-2 rounded-full bg-primary mr-2 animate-pulse"></span>
                                Competitive Path
                            </div>
                            <h1 className="font-display font-bold text-3xl text-gray-900 dark:text-white mb-2">
                                Which exam are you targeting?
                            </h1>
                            <p className="text-gray-500 dark:text-gray-400">Choose your goal from the options below</p>
                        </div>

                        <form className="flex-grow flex flex-col">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                                {exams.map((exam) => (
                                    <label key={exam.id} className="relative group cursor-pointer">
                                        <input
                                            type="radio"
                                            name="exam"
                                            className="peer sr-only"
                                            checked={selectedExam === exam.id}
                                            onChange={() => setSelectedExam(exam.id)}
                                        />
                                        <div className="h-full p-5 rounded-2xl border-2 border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800 transition-all duration-200 hover:border-primary/50 peer-checked:border-primary peer-checked:bg-primary/5 dark:peer-checked:bg-primary/10 peer-checked:shadow-lg peer-checked:shadow-primary/10">
                                            <div className="flex items-center gap-4 mb-3">
                                                <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${getColorClass(exam.color)}`}>
                                                    <span className="material-symbols-outlined text-2xl">{exam.icon}</span>
                                                </div>
                                                <h4 className="font-display font-bold text-lg text-gray-900 dark:text-white">{exam.title}</h4>
                                            </div>
                                            <p className="text-sm text-gray-500 dark:text-gray-400 leading-snug">{exam.desc}</p>
                                            <div className="absolute top-4 right-4 w-6 h-6 rounded-full border-2 transition-all flex items-center justify-center text-transparent peer-checked:border-primary peer-checked:bg-primary peer-checked:text-white peer-checked:scale-110">
                                                <span className="material-symbols-outlined text-sm font-bold">check</span>
                                            </div>
                                        </div>
                                    </label>
                                ))}
                            </div>

                            <div className="mt-auto space-y-6">
                                <button
                                    onClick={onContinue}
                                    className="w-full flex justify-center py-4 px-4 border border-transparent rounded-xl shadow-lg shadow-primary/30 text-base font-bold text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all duration-200 hover:-translate-y-0.5"
                                    type="button"
                                >
                                    Continue to Dashboard
                                    <span className="material-symbols-outlined ml-2 text-sm">arrow_forward</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>

            <footer className="bg-surface-light dark:bg-surface-dark border-t border-gray-100 dark:border-gray-800 py-6">
                <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 dark:text-gray-400 font-medium">
                    <p>© 2023 Himigo Learning Platform. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a className="hover:text-gray-900 dark:hover:text-white transition-colors" href="#">Privacy Policy</a>
                        <a className="hover:text-gray-900 dark:hover:text-white transition-colors" href="#">Terms of Service</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Exam;
